import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchSentEmail } from "../actions/index";
import { CSSTransitionGroup } from 'react-transition-group';
import moment from "moment";
import * as DOMPurify from "dompurify";
import EmailBroadcastAttachments from "./EmailBroadcastAttachments";

class SentEmail extends Component {
  static propTypes = {
    fetchSentEmail: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    sentEmail: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = { };
  }

  componentDidMount() {
    this.props.fetchSentEmail(
      this.props.match.params.id
    );
  }

  renderEmailEvents() {
    if (!this.props.sentEmail.data) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.sentEmail.data.email_events.length == 0) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="well well-lg text-center">
              You have no email events.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.sentEmail.data.email_events.map(event => {
      return (
        <tr key={event.id}>
          <td>{moment(event.timestamp).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td className="capitalize">{event.event}</td>
          <td className="text-right">{event.code}</td>
          <td>{event.error}</td>
        </tr>
      );
    });
  }

  showResult(result) {
    if (result == "Delivered") {
      return <div className="alert alert-success">{result}</div>;
    } else {
      return <div className="alert alert-warning">{result}</div>;
    }
  }

  render() {
    const { sentEmail } = this.props;
    if (!sentEmail) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }

    return (
      <div>
        <h1>Email Details</h1>

        <h2>Result</h2>
        {this.showResult(sentEmail.data.result)}

        <h2>Log</h2>

        <div className="row m-l-0 m-r-0">
          <table className="table table-striped">
            <thead>
              <tr>
                <th className={`timestamp`} data-sort="timestamp">
                  Date
                </th>
                <th className={`event`} data-sort="event">
                  Event
                </th>
                <th className={`text-right code`} data-sort="code">
                  Code
                </th>
                <th className={`error`} data-sort="error">
                  Error
                </th>
                <th />
              </tr>
            </thead>
            <tbody>{this.renderEmailEvents()}</tbody>
          </table>
        </div>

        <h2>Content</h2>
        <div className="m-b-40">
          <div className="form-group">
            <label>To</label>
            <input
              type="text"
              className="form-control to_field"
              disabled="disabled"
              value={sentEmail.data.to}
            />
          </div>

          <div className="form-group">
            <label>From</label>
            <input
              type="text"
              className="form-control from_field"
              disabled="disabled"
              value={sentEmail.data.from}
            />
          </div>

          <div className="form-group">
            <label>Subject</label>
            <input
              type="text"
              className="form-control subject_field"
              disabled="disabled"
              value={sentEmail.data.subject}
            />
          </div>

          <div className="form-group">
            <label>Body</label>
            <div
              className="form-control body_field"
              disabled="disabled"
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(sentEmail.data.body_text)}} // eslint-disable-line import/namespace
            />
          </div>

          <EmailBroadcastAttachments
            eblast_attachments={sentEmail.data.eblast_attachments}
          />
        </div>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return { sentEmail: state.sentEmails.sent_email };
}

export default connect(
  mapStateToProps,
  { fetchSentEmail }
)(SentEmail);
